export const ONE_WEEK_IN_MINUTES = 7 * 24 * 60;
export var SegmentUploadOperationType;
(function (SegmentUploadOperationType) {
    SegmentUploadOperationType["AddSegments"] = "ADD_SEGMENTS";
    SegmentUploadOperationType["ReplaceAllSegments"] = "REPLACE_ALL_SEGMENTS";
    SegmentUploadOperationType["RemoveSegments"] = "REMOVE_SEGMENTS";
})(SegmentUploadOperationType || (SegmentUploadOperationType = {}));
//# sourceMappingURL=SegmentUpload.js.map